import { render, staticRenderFns } from "./reduce-amount.vue?vue&type=template&id=2a86b0f3&scoped=true"
import script from "./reduce-amount.vue?vue&type=script&lang=js"
export * from "./reduce-amount.vue?vue&type=script&lang=js"
import style0 from "./reduce-amount.vue?vue&type=style&index=0&id=2a86b0f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86b0f3",
  null
  
)

export default component.exports